<template>
  <div style="height: 65vh;margin: 0 4%;">
    <div class="text-blue padding-top-20">
      联动列表
    </div>
    <div style="overflow-y: auto;height:58vh">
      <el-table
        :data="tableData"
        height="calc(53vh - 50px)"
        class="table"
        border
        style="width: 100%;margin-top: 10px;">
        <el-table-column
          align="center"
          label="触发时间"
          prop="createTime">
        </el-table-column>
        <el-table-column
          align="center"
          label="联动结果"
          prop="success">
          <template slot-scope="scope">
            {{ scope.row.success ? '成功' : '失败' }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="备注说明"
          prop="msg">
        </el-table-column>
      </el-table>
    </div>
    <el-row style="margin-top: 15px;text-align: center;" v-if="dateTotal>pageForm.size">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :current-page.sync="pageForm.currentPage"
        :page-size="pageForm.size"
        :total="dateTotal">
      </el-pagination>
    </el-row>
  </div>
</template>

<script>
import {getPageByLinkageIdAndActionId} from "@/network/device-linkage-actiton-logs";

export default {
  name: "LinkageLogs",
  props: ["item"],
  data() {
    return {
      tableData: [],
      //总页数
      dateTotal:'',
      pageForm: {
        linkageId: '',
        //当前页数
        currentPage: 1,
        // 每页数
        size: 10,
        // size: 1,
      },
    }
  },
  watch: {
    item() {
      this.dateTotal=0;
      this.getListByLinkageIdAndActionId();
    },
  },
  mounted() {
    this.dateTotal=0;
    this.getListByLinkageIdAndActionId();
  },
  // 查询动作详情
  methods: {
    // 查询简单策略动作详情
    getListByLinkageIdAndActionId() {
      this.pageForm.linkageId = this.item.id;
      // this.pageForm.linkageId ='167305867501375488';
      getPageByLinkageIdAndActionId(this.pageForm.currentPage,this.pageForm.size,this.pageForm.linkageId,'').then(res => {
        console.log(res);
        if (res.code === 0) {
          let bln = res.data == null;
          this.tableData = res.data.records;
          // 总数
          this.dateTotal = bln ? 0 : res.data.total;
          console.log(this.dateTotal)
          // 每页数
          this.pageForm.size = bln ? 10 : res.data.size;
          this.pageForm.currentPage = bln ? 1 : res.data.current;
        }
      });
    },
    // 翻页
    handleCurrentChange(val) {
      //当前为第几页时调用getData()显示第几页数据
      this.pageForm.pageCurrent = val;
      this.pageForm.pageSize = 10;
      this.getListByLinkageIdAndActionId();
    },
  }
}
</script>

<style scoped>

</style>
